<div id="{{ctx.id}}" class="{% if (! ctx.visible) { %}formio-component formio-component--hidden{% } %}" {% if (ctx.styles) { %} styles="{{ctx.styles}}"{% } %} ref="component">
  {% if (ctx.visible) { %}
    {{ctx.children}}
  {% } %}
</div>
